import React from "react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Calendar } from "../ui/calendar";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { CalendarDays } from "lucide-react";

export const combineDateTime = (date, time) => {
  if (!date) return null;
  const [h, m] = (time || "00:00").split(":").map(Number);
  const d = new Date(date);
  d.setHours(h || 0, m || 0, 0, 0);
  return d.toISOString();
};

export function DateTimePicker({ date, time, onDate, onTime }) {
  return (
    <div className="flex gap-2">
      <Popover>
        <PopoverTrigger asChild>
          <Button variant="outline" className="flex-1 justify-start font-normal gap-2 rounded-sm" data-testid="incident-detected-date-btn">
            <CalendarDays size={14} />{date ? date.toLocaleDateString("en-GB") : "Now"}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar mode="single" selected={date} onSelect={onDate} disabled={(d) => d > new Date()} initialFocus />
        </PopoverContent>
      </Popover>
      <Input type="time" value={time} onChange={(e) => onTime(e.target.value)} disabled={!date} className="w-28 rounded-sm" data-testid="incident-detected-time" />
    </div>
  );
}
